import { Editor } from '@tiptap/react';
import { useCallback, useEffect } from 'react';
import { Lyrics2Configuration } from 'types/lyrics.types';
import { useAppDispatch } from 'app/store';
import { addAlertAction } from 'app/store/Alerts/slice';
import throttle from 'lodash/throttle';

const CHAR_LIMIT_TOAST_ID = 'CHAR_LIMIT_TOAST';

const getCount = (editor: Editor | null) =>
  editor?.storage?.characterCount?.characters?.();

export const useCharLimit = (
  editor: Editor | null,
  config: Lyrics2Configuration
) => {
  const dispatch = useAppDispatch();
  const charLimit = (config.extensions?.CharacterCount?.configuration as {
    limit: number;
  })?.limit;

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const dispatchMessage = useCallback(
    throttle(
      () =>
        dispatch(
          addAlertAction({
            message: `Lyrics have a limit of ${Intl.NumberFormat().format(
              charLimit
            )} characters.`,
            id: CHAR_LIMIT_TOAST_ID,
          })
        ),
      1500
    ),
    [dispatch, charLimit]
  );

  const checkLimit = useCallback(
    (count: number) => {
      if (count >= charLimit) {
        dispatchMessage();
      }
    },
    [charLimit, dispatchMessage]
  );

  useEffect(() => {
    const handler = () => {
      const count = getCount(editor);
      checkLimit(count);
    };

    editor?.on('update', handler);

    return () => {
      editor?.off('update', handler);
    };
  }, [checkLimit, editor]);
};
